import React, { Suspense } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useCalendar } from '../calendarContext';
import DayView from './dayView';

// Lazy load the components 
const WeekViewDesktop = React.lazy(() => import('../week/weekView_desktop'));

const WeekView = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen size is small
    const { selectedDate, bookingDatas } = useCalendar();
    // A narrow-screen fallback must not overwrite the user's saved Week choice.
    if (isSmallScreen) return <DayView />;

    return (
        <Suspense fallback={<div>Loading...</div>}>
            {!isSmallScreen &&
                <WeekViewDesktop selectedDate={selectedDate} bookingDatas={bookingDatas} />}
        </Suspense>
    );
};

export default WeekView;
